'use strict';

var type = require('../value/type');

var getInitial = function getInitial(item) {
  switch (type(item)) {
    case 'array':
      return [];
    case 'object':
      return {};
    case 'string':
      return '';
    case 'number':
      return 0;
    default:
      return item;
  }
};

module.exports = getInitial;


//////////////////
// WEBPACK FOOTER
// ./~/fun-util/lib/utils/getInitial.js
// module id = 1048
// module chunks = 37